module.exports = __webpack_public_path__ + "static/media/annualurs.9af95a01.jpg";